export const tr = {
    'center-bottom': 'Orta alt',
    'center-center': 'Orta orta',
    'center-top': 'Orta üst',
    default: '-',
    'left-bottom': 'Sol alt',
    'left-center': 'Sol orta',
    'left-top': 'Sol üst',
    'right-bottom': 'Sağ alt',
    'right-center': 'Sağ orta',
    'right-top': 'Sağ üst'
};
